/**
 * 背包系统类型定义
 * 一期目标：区分“可堆叠物资”与“不可堆叠物品实例”
 */

import { z } from 'zod';
import { ItemInstanceSchema } from './item';

// ============================================
// 背包系统
// ============================================

/**
 * 可堆叠物资（材料/消耗品等）
 */
export const StackableItemSchema = z.object({
  definitionId: z.string(),
  quantity: z.number().int().min(1),
  slot: z.number().optional(), // 背包格子位置
  metadata: z.record(z.string(), z.unknown()).optional(), // 物品额外数据（如耐久度）
});

export type StackableItem = z.infer<typeof StackableItemSchema>;

/**
 * 背包状态
 */
export const InventorySchema = z.object({
  gold: z.number().min(0).default(0),
  stackables: z.array(StackableItemSchema).default([]),
  /** 非堆叠实例事实源（instanceId -> ItemInstance） */
  instanceData: z.record(z.string(), ItemInstanceSchema).default({}),
  capacity: z.number().default(100),
});

export type Inventory = z.infer<typeof InventorySchema>;
